import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { mobileAtom } from '../stores/layout';

const MOBILE_WIDTH_STANDARD = 1024;

const useMediaQuery = () => {
  const setIsMobile = useSetAtom(mobileAtom);

  useEffect(() => {
    const vh = window.innerHeight;
    document.documentElement.style.setProperty('--app-height', `${vh}px`);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_WIDTH_STANDARD}px)`);
    const handleMediaChange = ({ matches }) => {
      setIsMobile(matches);
    };
    mediaQuery.addEventListener('change', handleMediaChange);
    setIsMobile(mediaQuery.matches);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, [setIsMobile]);
};

export default useMediaQuery;
